<template>
  <b-container>
    <b-row>
      <b-col cols="4">
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row class="mb-1">
              <b-col md="12">
                <label class="mb-1 text-primary font-weight-bold"
                  >Details Receiving</label
                >
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="4"> Code </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    <div v-if="detail.code === ''">-</div>
                    <div v-else>{{ detail.code }}</div>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Date </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ moment(detail.date) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Warehouse </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ detail.warehouse }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Code Ref </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    <div v-if="detail.code_ref === ''">-</div>
                    <div v-else>{{ detail.code_ref }}</div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <label class="my-1" v-if="this.detail.file1 !== null"
              >Attachments</label
            >
            <b-row>
              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1 mb-1"
                  pill
                  v-if="this.detail.file1 !== null"
                  @click="link(detail.file1)"
                >
                  Attachment 1
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1 mb-1"
                  pill
                  v-if="this.detail.file2 !== null"
                  @click="link(detail.file2)"
                >
                  Attachment 2
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1 mb-1"
                  pill
                  v-if="this.detail.file3 !== null"
                  @click="link(detail.file3)"
                >
                  Attachment 3
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1 mb-1"
                  pill
                  v-if="this.detail.file4 !== null"
                  @click="link(detail.file4)"
                >
                  Attachment 4
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1 mb-1"
                  pill
                  v-if="this.detail.file5 !== null"
                  @click="link(detail.file5)"
                >
                  Attachment 5
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row class="mb-1">
              <b-col md="12">
                <label class="mb-1 text-primary font-weight-bold"
                  >Details Purchase</label
                >
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="4"> Code </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ purchase.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Date </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ moment(purchase.date) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Vendor </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ purchase.vendor }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Tax </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ formatRupiah(purchase.tax) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Additional Cost </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ formatRupiah(purchase.additional_cost) }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="4"> Total Price </b-col>
                  <b-col md="8" class="text-right font-weight-bolder">
                    {{ formatRupiah(purchase.total_price) }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="8">
        <b-card>
          <b-form v-on:submit.prevent enctype="multipart/form-data">
            <b-row>
              <b-col md="12">
                <label for="items" class="text-primary font-weight-bold"
                  >List Items</label
                >
              </b-col>
              <b-col md="12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                  <b-form-group>
                    <div class="d-flex align-items-center">
                      <label class="mr-1">Search</label>
                      <b-form-input
                        v-model="searchTerm"
                        placeholder="Search"
                        type="text"
                        class="d-inline-block"
                      />
                    </div>
                  </b-form-group>
                </div>
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                            :src="props.row.avatar"
                                            class="mx-1"
                                        /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">{{
                        formatRupiah(props.row.price)
                      }}</span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BModal,
  VBModal,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import moment from "moment";

export default {
  components: {
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BModal,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      detail: {
        purchase_id: null,
        warehouse: "",
        code: "",
        code_ref: "",
        date: null,
        file1: null,
        file2: null,
        file3: null,
        file4: null,
        file5: null,
      },
      purchase: {
        code: "",
        tax: null,
        additional_cost: null,
        total_price: null,
        vendor: "",
        date: null,
      },
      hasImage: "",
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Code",
          field: "code",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Price",
          field: "price",
        },
      ],
      permissions: [],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-warning",
        1: "light-info",
        2: "light-primary",
        3: "light-success",
        4: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("procurement/receiving/" + id).then((response) => {
        // console.log(response.data.data)
        this.detail.purchase_id = response.data.data.purchase_id;
        this.detail.warehouse = response.data.data.warehouse_name;
        this.detail.code = response.data.data.code;
        this.detail.code_ref = response.data.data.code_ref;
        this.detail.date = response.data.data.created_at;
        const { baseUrl } = $themeConfig.app;
        if (response.data.data.attachment_1 !== null) {
          this.detail.file1 = baseUrl;
          this.detail.file1 += "storage/procurement/receiving/";
          this.detail.file1 += response.data.data.attachment_1;
        }
        if (response.data.data.attachment_2 !== null) {
          this.detail.file2 = baseUrl;
          this.detail.file2 += "storage/procurement/receiving/";
          this.detail.file2 += response.data.data.attachment_2;
        }
        if (response.data.data.attachment_3 !== null) {
          this.detail.file3 = baseUrl;
          this.detail.file3 += "storage/procurement/receiving/";
          this.detail.file3 += response.data.data.attachment_3;
        }
        if (response.data.data.attachment_4 !== null) {
          this.detail.file4 = baseUrl;
          this.detail.file4 += "storage/procurement/receiving/";
          this.detail.file4 += response.data.data.attachment_4;
        }
        if (response.data.data.attachment_5 !== null) {
          this.detail.file5 = baseUrl;
          this.detail.file5 += "storage/procurement/receiving/";
          this.detail.file5 += response.data.data.attachment_5;
        }
        this.getPurchase();
        this.getPurchaseItems();
      });
    },
    getPurchase() {
      this.$http
        .get("procurement/purchase/" + this.detail.purchase_id)
        .then((response) => {
          // console.log(response.data.data)
          this.purchase.code = response.data.data.code;
          this.purchase.tax = response.data.data.tax;
          this.purchase.additional_cost = response.data.data.additional_cost;
          this.purchase.total_price = response.data.data.total_price;
          this.purchase.vendor = response.data.data.vendor_name;
          this.purchase.date = response.data.data.created_at;
        });
    },
    getPurchaseItems() {
      this.$http
        .get("procurement/purchases/" + this.detail.purchase_id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          const { baseUrl } = $themeConfig.app;
          for (i = 0; i < datas.length; i++) {
            this.photo = baseUrl;
            this.photo += "storage/product/";
            this.photo += datas[i].product_image;
            // console.log(this.photo)
            var $data = {
              value: datas[i].id,
              image: this.photo,
              code: datas[i].purchase_code,
              name: datas[i].product_name,
              qty: datas[i].qty,
              unit_name: datas[i].unit_name,
              price: datas[i].price,
            };
            // console.log($data)
            this.rows.push($data);
          }
        });
    },
    link(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>